import React, { FC } from 'react';
import { InspirationalTemplate as Template } from '../../../domain/entities/inspirationalTemplate';
import { TemplateImage } from '../../TemplateImage/TemplateImage';
import { QuickViewButton } from '../../QuickViewButton/QuickViewButton';

import s from './InspirationalTemplatesGridItem.scss';

interface InspirationalTemplateProps {
  template: Template;
  index?: number;
}

export const InspirationalTemplatesGridItem: FC<InspirationalTemplateProps> = ({
  template,
  index,
}) => (
  <div className={s.container}>
    <div className={s.imageCell}>
      <TemplateImage
        className={s.templateImage}
        template={template}
        isLazyLoad={false}
      />
    </div>
    <div className={s.textCell}>
      <div className={s.titleAndDescription}>
        <div className={s.title}>{template.title}</div>
        <div className={s.description}>{template.description}</div>
      </div>
      <div className={s.quickView}>
        <QuickViewButton template={template} index={index} />
      </div>
    </div>
  </div>
);
